export default "__VITE_ASSET__7e09Lr6q__"